import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingContentService {
  private dataSource = new BehaviorSubject<boolean>(false);
  loading = this.dataSource.asObservable();

  constructor() { }

  show() {
    this.dataSource.next(true);
  }

  hide() {
    this.dataSource.next(false);
  }
}
